import React from 'react';
import './AttractionsSection.css';

const attractions = [
  {
    icon: '🏰',
    name: 'Amer Fort',
    distance: '~12 km',
    description: 'A magnificent fort palace showcasing Rajput architecture, mirror work, and stunning hill views.',
    image: '/images/amer-fort.avif'
  },
  {
    icon: '🪟',
    name: 'Hawa Mahal',
    distance: '~6 km',
    description: 'The iconic Palace of Winds with 953 windows, a symbol of Jaipur\'s architectural brilliance.',
    image: '/images/hawa-mahal.avif'
  },
  {
    icon: '👑',
    name: 'City Palace',
    distance: '~6 km',
    description: 'Royal residence complex with museums, courtyards, and exquisite Rajasthani and Mughal architecture.',
    image: '/images/city-palace.avif'
  },
  {
    icon: '🔭',
    name: 'Jantar Mantar',
    distance: '~6 km',
    description: 'UNESCO World Heritage astronomical observatory with the world\'s largest stone sundial.',
    image: '/images/jantar-mantar.avif'
  },
  {
    icon: '💧',
    name: 'Jal Mahal',  
    distance: '~8 km',
    description: 'Beautiful water palace in the middle of Man Sagar Lake, perfect for photography.',
    image: '/images/jal-mahal.avif'
  },
  {
    icon: '🏔️',
    name: 'Nahargarh Fort',
    distance: '~10 km',
    description: 'Hill fort offering panoramic views of Jaipur, especially beautiful at sunset.',
    image: '/images/nahargarh-fort.avif'
  },
  {
    icon: '🛍️',
    name: 'Shopping Markets',
    distance: '5-7 km',
    description: 'Johari Bazaar, Bapu Bazaar, Tripolia Bazaar - famous for jewelry, textiles, and handicrafts.',
    image: '/images/shopping-markets.avif'
  },
  {
    icon: '🛕',
    name: 'Birla Mandir',
    distance: '~4 km',
    description: 'Beautiful white marble temple dedicated to Lord Vishnu and Goddess Lakshmi.',
    image: '/images/birla-mandir.avif'
  }
];

const AttractionsSection = () => {
  return (
    <section className="attractions-section">
      <div className="attractions-container">
        <div className="attractions-intro">
          <h2>Explore Jaipur - Nearby Attractions</h2>
          <p>Our hotel's central location in Nehru Nagar makes it easy to explore Jaipur's magnificent attractions. Here are the must-visit places:</p>
        </div>
        <div className="attractions-grid">
          {attractions.map((item, index) => (
            <div key={index} className="attraction-card">
              <div className="attraction-image">
                <img src={item.image} alt={item.name} />
                <div className="attraction-icon">{item.icon}</div>
              </div>
              <div className="attraction-content">
                <h3>{item.name}</h3>
                <span className="attraction-distance">Distance: {item.distance}</span>
                <p className="attraction-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AttractionsSection;
